import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule,ReactiveFormsModule  } from "@angular/forms";
import { TagInputModule } from "ngx-chips";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { RouterModule } from "@angular/router";

import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ProjectComponent } from './project/project.component';
import { ProjectsRoutes } from "./projects.routing";
import { ProjectDetailComponent } from "./project-detail/project-detail.component";
import { BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerModule } from "ngx-spinner";
import { ComponentsModule } from "../../components/components.module";
import { EmergencyGrantApplicationComponent } from './emergency-grant-application/emergency-grant-application.component';
import { ProjectFormDetailComponent } from './project-detail/project-form-detail/project-form-detail.component';
import {truncateWordWithNoSpace} from "../../pipes/truncate-description.pipe";


@NgModule({
  declarations: [
    ProjectComponent,
    ProjectDetailComponent,
    EmergencyGrantApplicationComponent,
    ProjectFormDetailComponent,
    truncateWordWithNoSpace,
  ],
  providers: [
    BsModalService,
  ],
  exports: [
    ProjectFormDetailComponent,
    truncateWordWithNoSpace
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(ProjectsRoutes),
    FormsModule,
    ReactiveFormsModule,
    TagInputModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ProgressbarModule.forRoot(),
    TooltipModule.forRoot(),
    PaginationModule.forRoot(),
    NgxSpinnerModule,
    ComponentsModule
  ]
})
export class ProjectsModules {}
